import React from 'react';
import './Home.css';

const Home = () => (
  <div className="home-page">
    <h2>Welcome to our page</h2>
    <p>
      This is my first React SPA project,
      if you click &quot;calculator&quot; on the header,
      then you will see a calculator similar to Apple&apos;s design.
      And you can see a random quote about computer if you click &quot;quote&quot;.
    </p>
  </div>
);

export default Home;
